import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CompanyLenses } from 'src/app/models/company-lenses.model';
import { ProductDataSubject } from 'src/app/models/product-data-subject.model';
import { ItemDetailsRequest } from 'src/app/models/requests/item-details-request.model';
import { CompanyLensesVM } from 'src/app/models/view-models/company-lenses-vm.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { OrderManagerService } from 'src/app/services/local/order-manager.service';
import { CompanyComputerLensesService } from 'src/app/services/repositories/company-computer-lenses.service';
import { CompanyDressLensesService } from 'src/app/services/repositories/company-dress-lenses.service';
import { CompanyLensesService } from 'src/app/services/repositories/company-lenses.service';

@Component({
    selector: 'app-lens-readers',
    templateUrl: './lens-readers.component.html',
    styleUrls: ['./lens-readers.component.scss'],
    standalone: false
})
export class LensReadersComponent implements OnInit {
  toggleClass: boolean = true;
  selectedLens: CompanyLenses | undefined;
  companyLensesVm: CompanyLensesVM[] = [];
  currentParentClass = "lens-module";
  productNameParam: string | null | undefined;
  lenses: { lensId: number; strength: string; isSelected: boolean }[] = [];
  tempCartEventsSubject: Subject<ProductDataSubject> = new Subject<ProductDataSubject>();
  isEditMode: boolean = false;
  queryParams: {} = {};

  constructor(private _cartManagerService: CartManagerService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _companyLensesService: CompanyLensesService,
              private _companyComputerLensesService: CompanyComputerLensesService,
              private _companyDressLensesService: CompanyDressLensesService,
              public _orderManagerService: OrderManagerService) { }


  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
      this.getReaderLenses();
    });
  }

  getReaderLenses() {
    const cartItem = this._cartManagerService.getTempCartItem();
    let lensObservable: any;
    if (cartItem) {
      switch (cartItem?.itemCategory) {
        case ORDER_CATEGORY.glasses:
          lensObservable = this._companyLensesService.getLenses(LENS_TYPES.singleVisionReaders);
          break;
        case ORDER_CATEGORY.computerGlasses:
          lensObservable = this._companyComputerLensesService.getLenses(LENS_TYPES.singleVisionReaders);
          break;
        case ORDER_CATEGORY.dressGlasses:
          lensObservable = this._companyDressLensesService.getLenses(LENS_TYPES.singleVisionReaders);
          break;
        default:
          this.redirectToDashboard();
      }
      lensObservable.subscribe((data: CompanyLenses[]) => {
        if (data) {
          this.populateStrengths(data);
        }
      }, (error: any) => {
        console.log(error);
      });
    }
    else {
      this.redirectToDashboard();
    }
  }

  redirectToDashboard() {
    this._router.navigate(['/dashboard']);
  }

  populateStrengths(companyLenses: CompanyLenses[]) {
    Object.assign(this.companyLensesVm, companyLenses);
    this.checkCartItems();
    for (let lens of this.companyLensesVm) {
      let readerStrength = parseFloat(lens.lensName.split(':', 2)[1]).toFixed(2);
      readerStrength = `+ ${readerStrength}`;
      this.lenses.push({lensId: lens.lensId, strength: readerStrength, isSelected: lens.isSelected});
    }
  }

  selectLens(lensId: string) {
    // undo previous selection
    let selectedLenses = this.lenses.filter(l => l.isSelected);
    selectedLenses.forEach(function (l) {
      l.isSelected = false;
    });
    // set new selected item
    let lens = this.lenses.find(cl => cl.lensId == parseInt(lensId));
    if (lens) {
      lens.isSelected = true;
    }
    this.selectedLens = this.companyLensesVm.find(cl => cl.lensId == lens?.lensId);
    this.saveLensSelection();
  }

  saveLensSelection() {
    if (this.selectedLens) {
      const cartItemDetail : ItemDetailsRequest = {
        id: this.selectedLens.lensId,
        itemType: ITEM_REVENUE_CATEGORY.lenses,
        itemDescription: this.selectedLens.lensDescription
      };
      this._cartManagerService.updateTempCartItemDetail(cartItemDetail);
      this.emitChangeToProductData();
    }
  }

  checkCartItems() {
    // check if option was already selected
    let cartItems = this._cartManagerService.getTempCartItem();
    let lens = cartItems?.itemDetails.find(id => id.itemType == 'lens');

    let companyLens =  this.companyLensesVm.find(clvm => clvm.lensId == lens?.id);
    if (companyLens) {
      companyLens.isSelected = true;
      this.currentParentClass = `lens${companyLens.lensId} selected`
    }
  }

  back() {
    this._cartManagerService.removeTempCartItemDetailByItemType(ITEM_REVENUE_CATEGORY.lenses);
    this._router.navigate(['/lens-selection'], { queryParams: this.queryParams });
  }

  emitChangeToProductData() {
    let pds: ProductDataSubject = { status: 'lens-update' };
    this.tempCartEventsSubject.next(pds);
  }

}
